import type { ImageSize } from '@cutr/constants/images';

type ThumbnailSource = {
  thumbnails?: Record<ImageSize, string>;
};

export function getThumbnailUrl(
  source: ThumbnailSource | null | undefined,
  size: ImageSize = 'sm'
): string | undefined {
  return source?.thumbnails?.[size] ?? undefined;
}
